import { render, staticRenderFns } from "./PublicLogin.vue?vue&type=template&id=b2caa9dc&scoped=true&"
import script from "./PublicLogin.vue?vue&type=script&lang=js&"
export * from "./PublicLogin.vue?vue&type=script&lang=js&"
import style0 from "./PublicLogin.vue?vue&type=style&index=0&id=b2caa9dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2caa9dc",
  null
  
)

export default component.exports